import { Component } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false,
})
export class LoginComponent {
  userData: any;
  isAuthenticated = false;

  constructor(private oidcSecurityService: OidcSecurityService) {
    // Revisa autenticación al inicio
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated, userData }) => {
      this.isAuthenticated = isAuthenticated;
      this.userData = userData;
      console.log('isAuthenticated:', isAuthenticated);
      console.log('userData:', userData);
    });
  }

  login() {
    this.oidcSecurityService.authorize(); // Redirige al IdP
  }

  logout() {
    this.oidcSecurityService.logoff();
  }

  showTokens() {
    this.oidcSecurityService.getAccessToken().subscribe((token) => {
      console.log('Access Token:', token);
    });
  }
}
